/** @module csi/slicer/ChartForm */
define([
	"dojo/_base/declare",
	"dojo/store/Memory",
	"csi/_base/underscore",
	"csi/form/Widget",
	"csi/widget/FusionChartStore"
], function(declare,Memory,_,FormWidget,FusionChartStore) {

	var SlicerChartStore = new Memory({
		idProperty: FusionChartStore.idProperty,
		data: FusionChartStore.query({multiseries:true})
	});

	return declare(FormWidget, {
		/**
		 * Setup view parameters.
		 */
		_resolveView: function() {
			this.defView.getField("ChartTemplate").widgetParams = {store: SlicerChartStore};
			this.inherited(arguments);
		}
	});
});
